import { useSelector } from 'react-redux';
import type { RootReducerState } from '../redux/Reducers';
import type { ThemeType } from '../types/theme.type';
import { FETCH_STATUS } from '../types/enums/fetch-status.enum';

export const useTheme = (): {
  theme: ThemeType | null;
  status: FETCH_STATUS;
  domainTheme: ThemeType | null;
  domainThemeFetchStatus: FETCH_STATUS;
  organizationTheme: ThemeType | null;
  organizationThemeFetchStatus: FETCH_STATUS;
} => {
  const domainTheme = useSelector((state: RootReducerState) => state.sharedReducer.domainTheme);
  const domainThemeFetchStatus = useSelector((state: RootReducerState) => state.sharedReducer.domainThemeFetchStatus);
  const organizationTheme = useSelector((state: RootReducerState) => state.sharedReducer.organizationTheme);
  const organizationThemeFetchStatus = useSelector(
    (state: RootReducerState) => state.sharedReducer.organizationThemeFetchStatus
  );

  const theme = organizationTheme ?? domainTheme;
  const status = organizationTheme ? organizationThemeFetchStatus : domainThemeFetchStatus;

  return { theme, status, domainTheme, domainThemeFetchStatus, organizationTheme, organizationThemeFetchStatus };
};
